export default [
  {
    title: 'Dashboard',
    key: 'Dashboard',
    url: '/admin/DashboardTling',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Power BI',
    key: 'Surveys',
    url: '/admin/PowerBI',
    icon: 'icmn icmn-stats-bars',
  },
  {
    title: 'Campañas',
    key: 'Surveys',
    url: '/admin/SurveysAdmin',
    icon: 'icmn icmn-stats-bars',
  },
  {
    title: 'Charts',
    key: 'charts',
    children: [
      {
        title: 'Chartist',
        key: 'chartist',
        url: '/charts/chartist',
      },
      {
        title: 'Chart',
        key: 'chart',
        url: '/charts/chart',
      },
      {
        title: 'Peity',
        key: 'peity',
        url: '/charts/peity',
      },
      {
        title: 'C3',
        key: 'c3',
        url: '/charts/c3',
      },
    ],
  },
  {
    title: 'Usuarios',
    key: 'users',
    url: '/admin/users',
    icon: 'icmn icmn-users',
  },
  {
    title: 'Pagos',
    key: 'Pagos',
    url: '/admin/Payments',
    icon: 'fa fa-money',
  },
]



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuLeft/menuData.js